import { TableRow } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";

import tableStyles from './tableStyles';

export default withStyles(tableStyles)(TableRow);